import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import colors from 'theme/colors';
import indexPriority from 'theme/z-index';

const DOT_SIZE = 14;
const RING_SIZE = 36;

function UserLocationMark({ onClick }) {
  return (
    <LocationWrapper onClick={onClick}>
      <PulseRing />
      <Dot />
    </LocationWrapper>
  );
}

const pulse = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0.6;
  }
  70% {
    opacity: 0.15;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.6);
    opacity: 0;
  }
`;

const LocationWrapper = styled.div`
  position: absolute;
  left: ${-RING_SIZE / 2}px;
  top: ${-RING_SIZE / 2}px;
  width: ${RING_SIZE}px;
  height: ${RING_SIZE}px;
  z-index: ${indexPriority.normal};
  cursor: ${({ onClick }) => onClick ? 'pointer' : 'default'};
`;

const PulseRing = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.6);
  width: ${RING_SIZE}px;
  height: ${RING_SIZE}px;
  border-radius: 50%;
  background: ${colors.occasionalPurple}26;
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
`;

const Dot = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${DOT_SIZE}px;
  height: ${DOT_SIZE}px;
  border-radius: 50%;
  background: ${colors.occasionalPurple};
  border: 2.5px solid ${colors.neutralLight};
  box-shadow: 0 1px 4px rgba(26, 26, 26, 0.25);
`;

UserLocationMark.defaultProps = {
  onClick: null,
};

UserLocationMark.propTypes = {
  onClick: PropTypes.func,
};

export default UserLocationMark;
